import { EmailCodeModalContent } from './email-code-modal-content'
import { EmailEntityType } from '../email-code-form/types'
import { FC } from 'react'
import { FlowcodeType } from '@dtx-company/inter-app/src/types/flowcode'
import { HeapContainers } from '../../../../constants/heap'
import { Modal, ModalVariants } from '@dtx-company/shared-components/src'
import { useIsLargeTablet } from '@dtx-company/true-common/src/hooks/useIsLargeTablet'

export interface EmailCodeModalProps {
  open: boolean
  onClose: () => void
  flowcodeData?: FlowcodeType
  batchId?: string
  onSubmit?: ((toEmails: string) => Promise<void>) | null
  entityType?: EmailEntityType
  flowcodeImageUrl?: string
}

export const EmailCodeModal: FC<EmailCodeModalProps> = ({
  open,
  onClose,
  batchId,
  onSubmit = null,
  entityType,
  flowcodeImageUrl
}: EmailCodeModalProps): JSX.Element => {
  const isMobile = useIsLargeTablet()

  const modalContent = {
    batchId,
    onClose,
    onSubmit,
    entityType,
    flowcodeImageUrl
  }

  return (
    <Modal
      delay={250}
      open={open}
      onClose={() => onClose()}
      width={['100%', '100%', '550px']}
      height={['100%', '100%', flowcodeImageUrl ? '500px' : '350px']}
      variant={isMobile ? ModalVariants.FULLPAGE : ModalVariants.DESKTOP}
      position={['fixed', 'fixed', 'initial']}
      overflowY="auto"
      closeButtonId={`hp-${HeapContainers.EMAIL_FLOWCODE_MODAL}-dismiss_email_code_modal_x-btn`}
    >
      <EmailCodeModalContent {...modalContent} />
    </Modal>
  )
}

export const EmailTemplateModal: FC<EmailCodeModalProps> = (props: EmailCodeModalProps) => {
  return <EmailCodeModal {...props} entityType={EmailEntityType.TEMPLATE} />
}
